import {
  SubscriptionModel,
  SubscriptionStatus,
  SubscriptionEntity,
} from './types';

import { SUBSCRIPTION_STATES } from './constants';

/**
 * Defines subscription state
 * @param {string} state - subscription entity state
 * @param {string} scheduledCancellationAt - subscription entity scheduledCancellationAt
 * @param {number} nextProductId - subscription entity nextProductId
 * @returns {string} scheduledCancellationAt - scheduled cancellation date
 */
const setStatus = (
  state: string,
  scheduledCancellationAt?: string,
  nextProductId?: number
): SubscriptionStatus => {
  const status = SUBSCRIPTION_STATES[state] || 'active';
  if (status === 'active' && scheduledCancellationAt)
    return 'cancellation_scheduled';
  if (['active', 'trial'].includes(status) && nextProductId)
    return 'plan_change_scheduled';
  return status;
};

/**
 * Serializes subscription entity
 * @param {Subscription} subscription - subscription entity
 * @returns {SubscriptionModel} serialized models
 */
export const serializeSubscription = (
  subscription: SubscriptionEntity
): SubscriptionModel => {
  const { state, ...model } = subscription;
  return {
    ...model,
    status: setStatus(
      state,
      model.scheduledCancellationAt,
      model.nextProductId
    ),
  };
};
